import axios from 'axios';
import _get from 'lodash/get';
import { REQUEST_CALLUS, RECEIVE_CALLUS_RESPONSE, RECEIVE_CALLUS_ERROR } from '../constants/ActionTypes';

import { cancelRelatedArtilceRequest } from './action-related-article';
import { cancelArtilceRequest } from './action-article';
import { cancelTopicDataRequest } from './action-topic-data';
import { cancelTopicTreeRequest } from './action-message-topic-tree';

// Fetch Phone number
function requestCallUs() {
  cancelRelatedArtilceRequest();
  cancelArtilceRequest();
  cancelTopicDataRequest();
  cancelTopicTreeRequest();
  return {
    type: REQUEST_CALLUS,
    payload: undefined,
  };
}
function receiveCallUsError() {
  return {
    type: RECEIVE_CALLUS_ERROR,
    payload: undefined,
  };
}

function receiveCallUsResponse(response) {
  return {
    type: RECEIVE_CALLUS_RESPONSE,
    payload: response,
  };
}

function fetchPhoneNumber() {
  return (dispatch, getState) => {
    const topicRefId = _get(getState(), 'emailForm.topicRefId');
    dispatch(requestCallUs());
    return axios.get(`/smarthelp/phone-info?topicRefId=${topicRefId}`)
    .then(response => dispatch(receiveCallUsResponse(response.data)))
    .catch(() => dispatch(receiveCallUsError()));
  };
}

export default {
  fetchPhoneNumber,
};
